import React from 'react';
import PropTypes from 'prop-types';

const ThresholdReadout = ({
  areaThresholdExpanded,
  clampedAreaThreshold,
  setAreaThresholdExpanded,
}) => (
  <div className="uploadfield__threshold__container">
    <label>Field size</label>
    <div className="uploadfield__threshold__readout">
      <output className="uploadfield__threshold__readout__value">
        {clampedAreaThreshold[0]}&ndash;
        {clampedAreaThreshold[1]} acres
      </output>
      <div className="uploadfield__toggle">
        <input
          type="checkbox"
          className="uploadfield__toggle__checkbox"
          checked={areaThresholdExpanded}
          onChange={event => {
            setAreaThresholdExpanded(event.currentTarget.checked);
          }}
        />
        <span className="uploadfield__toggle__icon" />
      </div>
    </div>
  </div>
);
ThresholdReadout.propTypes = {
  areaThresholdExpanded: PropTypes.bool.isRequired,
  clampedAreaThreshold: PropTypes.arrayOf(PropTypes.number.isRequired)
    .isRequired,
  setAreaThresholdExpanded: PropTypes.func.isRequired,
};

export default ThresholdReadout;



// WEBPACK FOOTER //
// ./src/pages/Field/Upload/ThresholdReadout.js